import { InvoicesSettingsPageLayout } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/components/InvoicesSettingsPageLayout";
import { InvoicesSettingsPageProvider } from "@web-src/modules/invoices/pages/InvoicesSettingsPage/context/InvoicesSettingsPageProvider";
import { taxToTaxRow } from "@web-src/modules/invoices/helpers";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { invoicesApi } from "@web-src/modules/api/createApi";
import { LoadingSpinner } from "@jugl-web/ui-kit";
import { useState } from "react";
import { InvoiceSettingsPreview } from "./components/InvoiceSettingsPreview";
import { InvoiceSettingsForm } from "./components/InvoiceSettingsForm/InvoiceSettingsForm";
import { InvoiceSettingsFooterButtons } from "./components/InvoiceSettingsFooterButtons";
import { useInvoicesConfigList } from "./hooks/useInvoicesConfigList";

export const InvoicesBusinessInformationPage = () => {
  const { entity } = useEntitySelectedProvider();
  const { configId, isLoading: isLoadingConfigList } = useInvoicesConfigList();

  const [logo, setLogo] = useState<File | undefined | null>(undefined);

  const getReponseData = invoicesApi.useGetConfigQuery({
    entityId: entity.id,
    configId,
  });

  const data = getReponseData.data?.data;

  const invoiceTaxes = data?.tax?.filter((tax) => tax.type === "total") || [];
  const itemTaxes = data?.tax?.filter((tax) => tax.type === "item") || [];

  const customFields = data?.header?.custom_field
    ? Object.entries(data.header.custom_field).map(([name, value]) => ({
        name,
        value,
      }))
    : [];

  const isLoadingConfig = getReponseData.isLoading;

  (async () => {
    if (logo !== undefined || isLoadingConfig || isLoadingConfigList) return;

    try {
      if (data?.logo && configId) {
        const url = data.logo;
        const response = await fetch(url || "");
        const blob = await response.blob();
        const file = new File([blob], "logo.png", { type: "image/png" });
        setLogo(file);
      } else if (!configId) {
        setLogo(null);
      }
    } catch {
      setLogo(null);
    }
  })();

  const isLoadingLogo = data?.logo && logo === undefined;

  return (
    <InvoicesSettingsPageLayout tab="business-information">
      {isLoadingConfigList || isLoadingConfig || isLoadingLogo ? (
        <div className="flex h-full items-center justify-center">
          <LoadingSpinner />
        </div>
      ) : data?.header?.company_name || !configId ? (
        <InvoicesSettingsPageProvider
          initialData={{
            name: data?.header?.company_name || "",
            street: data?.header?.street || "",
            state: data?.header?.state || "",
            country: data?.header?.country || "",
            city: data?.header?.city || "",
            zipCode: data?.header?.zip_code || "",
            note: data?.footer?.notes || "",
            dueIn: data?.due_in || 7,
            customFields,
            taxFields: {
              item: itemTaxes.map(taxToTaxRow),
              invoice: invoiceTaxes.map(taxToTaxRow),
            },
            logo: logo ?? undefined,
          }}
        >
          <div className="grid grid-cols-2 gap-8 px-8">
            <InvoiceSettingsForm />
            <InvoiceSettingsPreview />
          </div>

          {configId ? null : <InvoiceSettingsFooterButtons />}
        </InvoicesSettingsPageProvider>
      ) : null}
    </InvoicesSettingsPageLayout>
  );
};
